import { Dispatch, SetStateAction } from 'react';

import Button from '@mui/material/Button';

import {
  Dialog,
  DialogActionsContainer,
  DialogContent,
  DialogHeader,
} from '@sbv-clients/ui-shared';
import { FunctionComponent } from '@sbv-clients/util-misc';

import {
  ConfirmDialogButtons,
  DialogMessage,
  smallDialogBodySx,
  smallDialogSx,
  useRedesignDialogs,
} from './dialog-message';

interface Props {
  showWarning: boolean;
  setShowWarning: Dispatch<SetStateAction<boolean>>;
  confirmDiscard: () => void;
}

export const DialogCloseGuardModal: FunctionComponent<Props> = ({
  showWarning,
  setShowWarning,
  confirmDiscard,
}) => {
  const redesign = useRedesignDialogs();
  if (redesign) {
    return (
      <Dialog
        open={showWarning}
        onClose={() => setShowWarning(false)}
        fullWidth
        sx={smallDialogSx}
      >
        <DialogHeader title="Unsaved Changes" />
        <DialogContent sx={smallDialogBodySx}>
          <DialogMessage tone="warn">
            You have unsaved changes. If you close now, your changes will be
            lost.
          </DialogMessage>
        </DialogContent>
        <DialogActionsContainer>
          <ConfirmDialogButtons
            cancelLabel="Keep Editing"
            confirmLabel="Discard Changes"
            onCancel={() => setShowWarning(false)}
            onConfirm={confirmDiscard}
          />
        </DialogActionsContainer>
      </Dialog>
    );
  }
  return (
    <Dialog open={showWarning} onClose={() => setShowWarning(false)}>
      <DialogHeader title={'Unsaved Changes'} />

      <DialogContent sx={{ mt: 6 }}>
        You have unsaved changes. If you close now, your changes will be lost.
        Do you want to continue?
      </DialogContent>

      <DialogActionsContainer>
        <Button variant={'outlined'} onClick={() => setShowWarning(false)}>
          Keep Editing
        </Button>

        <Button variant={'contained'} onClick={confirmDiscard}>
          Discard Changes
        </Button>
      </DialogActionsContainer>
    </Dialog>
  );
};
